import _ from "lodash";
import Owner from "@/model/cospirit-api/Owner";
import MasterOwnerRepository from "@/repositories/MasterOwnerRepository";
import store from "@/store";

export default {
    state: {
        owners: [],
    },
    mutations: {
        setMasterOwners: (state: any, owners: Owner[]) => {
            _.set(state, "owners", owners);
        },
    },
    getters: {
        getMasterOwners: (state: { owners: Owner[] }): Owner[] => {
            return state.owners;
        },
    },
    actions: {
        loadMasterOwners: ({ commit, dispatch, state }: any): Promise<void> => {
            return new Promise((resolve, reject) => {
                MasterOwnerRepository.list({
                    uuid: _.get(store, "getters.getCurrentOwnerUuid", "")
                }).then((data: any) => {
                    commit("setMasterOwners", data);
                    if (0 < data.length) {
                        resolve();
                    } else {
                        reject();
                    }
                });
            });
        },
    },
};
